// 排行维度
export const dimensionList = [
  {
    label: 'pc_biz_rank_integral',
    text: '积分',
    type: 1,
    key: 'integral'
  },
  {
    label: 'pc_biz_rank_studyscore',
    text: '学分',
    type: 2,
    key: 'credits'
  },
  {
    label: 'pc_biz_rank_exp',
    text: '经验值',
    type: 3,
    key: 'exp'
  },
  {
    label: 'pc_biz_rank_studyTime',
    text: '学习时长',
    type: 4,
    key: 'learningTime'
  }
];

// 排行周期
export const dateList = [
  {
    label: 'pc_biz_rank_this_week',
    text: '本周',
    type: 4,
    order: 1
  },
  {
    label: 'pc_biz_rank_this_month',
    text: '本月',
    type: 3,
    order: 2
  },
  {
    label: 'pc_biz_rank_this_quarter',
    text: '本季度',
    type: 5,
    order: 3
  },
  {
    label: 'pc_biz_rank_this_year',
    text: '本年',
    type: 2,
    order: 4
  },
  {
    label: 'pc_biz_rank_total_time',
    text: '全部时间',
    type: 1,
    order: 5
  }
];

// 参与对象
export const objectList = [
  {
    label: 'pc_biz_rank_employee',
    text: '员工',
    type: 1,
    key: 'user'
  },
  {
    label: 'pc_biz_rank_dept_per',
    text: '部门人均',
    type: 2,
    key: 'deptAvg'
  },
  {
    label: 'pc_biz_rank_dept_total',
    text: '部门总计',
    type: 3,
    key: 'deptSum'
  }
];

// 对象范围
export const rangeList = [
  // {
  //   label: 'pc_biz_rank_group_all_staff',
  //   text: '集团全体员工',
  //   type: 2
  // },
  {
    label: 'pc_biz_rank_platform_all_staff',
    text: '平台全体员工',
    type: 1
  },
  {
    label: 'pc_biz_rank_direct_dept_employee',
    text: '所属直属部门的员工',
    type: 3
  },
  {
    label: 'pc_biz_rank_first_dept_employee',
    text: '所属一级部门的员工',
    type: 4
  },
  {
    label: 'pc_biz_rank_second_dept_employee',
    text: '所属二级部门的员工',
    type: 5
  },
  {
    label: 'pc_biz_rank_third_dept_employee',
    text: '所属三级部门的员工',
    type: 6
  }
];

// 更多配置
export const configList = [
  [{
    label: 'pc_biz_rank_employee_integral_less',
    text: '员工积分小于等于'
  },
  {
    label: 'pc_biz_rank_dept_per_integral_less',
    text: '部门人均积分小于等于'
  },
  {
    label: 'pc_biz_rank_dept_total_integral_less',
    text: '部门总计积分小于等于'
  }],
  [{
    label: 'pc_biz_rank_employee_studyscore_less',
    text: '员工学分小于等于'
  },
  {
    label: 'pc_biz_rank_dept_per_studyscore_less',
    text: '部门人均学分小于等于'
  },
  {
    label: 'pc_biz_rank_dept_total_studyscore_less',
    text: '部门总计学分小于等于'
  }],
  [{
    label: 'pc_biz_rank_employee_exp_less',
    text: '员工经验值小于等于'
  },
  {
    label: 'pc_biz_rank_dept_per_exp_less',
    text: '部门人均经验值小于等于'
  },
  {
    label: 'pc_biz_rank_dept_total_exp_less',
    text: '部门总计经验值小于等于'
  }],
  [{
    label: 'pc_biz_rank_employee_studyTime_less',
    text: '员工学习时长小于等于'
  },
  {
    label: 'pc_biz_rank_dept_per_studyTime_less',
    text: '部门人均学习时长小于等于'
  },
  {
    label: 'pc_biz_rank_dept_total_studyTime_less',
    text: '部门总计学习时长小于等于'
  }]
];

// 相同数值排名
export const typeList = [
  {
    label: 'pc_biz_rank_order_rank',
    type: 2,
    text: '顺序排名',
    icon: 'rank_type2'
  },
  {
    label: 'pc_biz_rank_tied_rank',
    type: 1,
    text: '并列排名',
    icon: 'rank_type1'
  }
];

// 展示样式
export const styleList = [
  {
    label: 'pc_biz_rank_list_style',
    type: 1,
    text: '列表式',
    icon: 'rank_style1'
  },
  {
    label: 'pc_biz_rank_hor_style',
    type: 2,
    text: '横排式',
    icon: 'rank_style2'
  }];

// 展示内容 -- 上榜主体是员工
export const userContentList = [
  {
    label: 'pc_biz_rank_head_portrait',
    text: '头像',
    type: 'userImgUrl'
  },
  {
    label: 'pc_biz_rank_name',
    text: '姓名',
    type: 'fullname'
  },
  {
    label: 'pc_biz_rank_dept_name',
    text: '部门名称',
    type: 'deptName',
    select: true
  },
  {
    label: 'pc_biz_rank_org_name',
    text: '平台名称',
    type: 'orgName',
    select: true
  }
];

// 展示内容 -- 上榜主体是部门
export const deptContentList = [
  {
    label: 'pc_biz_rank_dept_name',
    text: '部门名称',
    type: 'deptName'
  },
  {
    label: 'pc_biz_rank_dept_icon',
    text: '部门图标',
    type: 'deptImg',
    select: true
  }
];

// 展示内容 -- 排行维度的文案
export const dimensionContentList = [
  [{
    label: 'pc_biz_rank_integral',
    text: '积分',
    type: 'integral'
  },
  {
    label: 'pc_biz_rank_per_integral',
    text: '人均积分',
    type: 'integral'
  },
  {
    label: 'pc_biz_rank_total_integral',
    text: '总计积分',
    type: 'integral'
  }],
  [{
    label: 'pc_biz_rank_studyscore',
    text: '学分',
    type: 'credits'
  },
  {
    label: 'pc_biz_rank_per_studyscore',
    text: '人均学分',
    type: 'credits'
  },
  {
    label: 'pc_biz_rank_total_studyscore',
    text: '总计学分',
    type: 'credits'
  }],
  [{
    label: 'pc_biz_rank_exp',
    text: '经验值',
    type: 'exp'
  },
  {
    label: 'pc_biz_rank_per_exp',
    text: '人均经验值',
    type: 'exp'
  },
  {
    label: 'pc_biz_rank_total_exp',
    text: '总计经验值',
    type: 'exp'
  }],
  [{
    label: 'pc_biz_rank_studyTime',
    text: '学习时长',
    type: 'learningTime'
  },
  {
    label: 'pc_biz_rank_per_studyTime',
    text: '人均学习时长',
    type: 'learningTime'
  },
  {
    label: 'pc_biz_rank_total_studyTime',
    text: '总计学习时长',
    type: 'learningTime'
  }]
];

// 榜单名称
export const nameList = [
  [{
    label: 'pc_biz_rank_employee_integral_rank',
    text: '员工积分榜'
  },
  {
    label: 'pc_biz_rank_dept_per_integral_rank',
    text: '部门人均积分榜'
  },
  {
    label: 'pc_biz_rank_dept_total_integral_rank',
    text: '部门总计积分榜'
  }],
  [{
    label: 'pc_biz_rank_employee_studyscore_rank',
    text: '员工学分榜'
  },
  {
    label: 'pc_biz_rank_dept_per_studyscore_rank',
    text: '部门人均学分榜'
  },
  {
    label: 'pc_biz_rank_dept_total_studyscore_rank',
    text: '部门总计学分榜'
  }],
  [{
    label: 'pc_biz_rank_employee_exp_rank',
    text: '员工经验值榜'
  },
  {
    label: 'pc_biz_rank_dept_per_exp_rank',
    text: '部门人均经验值榜'
  },
  {
    label: 'pc_biz_rank_dept_total_exp_rank',
    text: '部门总计经验值榜'
  }],
  [{
    label: 'pc_biz_rank_employee_studyTime_rank',
    text: '员工学习时长榜'
  },
  {
    label: 'pc_biz_rank_dept_per_studyTime_rank',
    text: '部门人均学习时长榜'
  },
  {
    label: 'pc_biz_rank_dept_total_studyTime_rank',
    text: '部门总计学习时长榜'
  }]
];

// 榜单名称 -- 简洁版
export const simpleNameList = [
  {
    label: 'pc_biz_rank_integral_rank',
    text: '积分榜'
  },
  {
    label: 'pc_biz_rank_studyscore_rank',
    text: '学分榜'
  },
  {
    label: 'pc_biz_rank_exp_rank',
    text: '经验值榜'
  },
  {
    label: 'pc_biz_rank_studyTime_rank',
    text: '学习时长榜'
  }
];
